import React, { forwardRef, useImperativeHandle } from 'react';
import { Box } from '@mui/material';

import MarkerAddDataProfile from './MarkerAddDataProfile';

import 'assets/styles/MarkerTable.scss';

interface MarkerActionBarProps {
  kpiLayerSelected: boolean;
  handleLoadKPIValues: () => void;
  addDataProfileDisabled?: boolean;
}

export interface MarkerActionBarRef {}

const MarkerActionBar: React.ForwardRefRenderFunction<
  MarkerActionBarRef,
  MarkerActionBarProps
> = (
  { handleLoadKPIValues, kpiLayerSelected, addDataProfileDisabled = false },
  ref
) => {
  useImperativeHandle(ref, () => ({}));

  return (
    <Box className="marker-action-bar-container">
      <Box
        className={`load-kpi-button ${
          kpiLayerSelected ? 'load-kpi-button-disabled' : ''
        }`}
        onClick={() => {
          !kpiLayerSelected && handleLoadKPIValues();
        }}
      >
        Load KPI values
      </Box>
      <MarkerAddDataProfile addDataProfileDisabled={addDataProfileDisabled} />
    </Box>
  );
};

export default forwardRef<MarkerActionBarRef, MarkerActionBarProps>(
  MarkerActionBar
);
